export const PO_STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  open: { label: "Open", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  ready: { label: "Ready", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  received: { label: "Received", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-400 border-slate-200" },
  // legacy keys kept for older views
  in_production: { label: "In Production", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  in_transit: { label: "In Transit", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  arrived: { label: "Arrived", cls: "bg-sky-50 text-sky-700 border-sky-200" },
};

export const PO_SHIPMENT_META = {
  not_shipped: { label: "Not Shipped", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ready_for_pickup: { label: "Ready for Pickup", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  scheduled: { label: "Scheduled", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  in_transit: { label: "In Transit", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  partially_delivered: { label: "Partially Delivered", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  delivered: { label: "Delivered", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-400 border-slate-200" },
};

export const PO_RECEIVING_META = {
  not_received: { label: "Not Received", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  partial: { label: "Partially Received", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  received: { label: "Fully Received", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  discrepancy: { label: "Discrepancy", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const PO_INVOICE_META = {
  not_invoiced: { label: "Not Invoiced", cls: "bg-slate-100 text-slate-400 border-slate-200" },
  unpaid: { label: "Unpaid", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  partially_paid: { label: "Partially Paid", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  overdue: { label: "Overdue", cls: "bg-red-50 text-red-700 border-red-200" },
  disputed: { label: "Disputed", cls: "bg-purple-50 text-purple-700 border-purple-200" },
};

export const PO_PRIORITY_META = {
  1: { label: "1 — Urgent", short: "1 Urgent", cls: "bg-red-100 text-red-700 border-red-300" },
  2: { label: "2 — High", short: "2 High", cls: "bg-orange-100 text-orange-700 border-orange-300" },
  3: { label: "3 — Normal", short: "3 Normal", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  4: { label: "4 — Low", short: "4 Low", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function POStatusBadge({ status, partial = false }) {
  const meta = PO_STATUS_META[status] || PO_STATUS_META.open;
  const label = partial && status !== "received" ? `${meta.label} · Partially Received` : meta.label;
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${partial && status !== "received" ? "border-amber-200 bg-amber-50 text-amber-700" : meta.cls}`}>
      {label}
    </span>
  );
}

export function PoBadge({ meta, testId }) {
  if (!meta) return null;
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${meta.cls}`}>
      {meta.label}
    </span>
  );
}
